export default __webpack_public_path__ + "static/lower4_3-43c17f7c2cb91f6dad4610c148dade3f.jpg";